import { PublicClientApplication } from '@azure/msal-browser';
import { Capacitor } from '@capacitor/core';
import { getConfig } from '../../../config/environment';

const {
  entraClientId,
  entraTenantSubdomain: tenantSubdomain,
  entraTenantId: tenantId,
  appUrl,
  appId,
} = getConfig();
const clientId = entraClientId ?? '';

const isNative = Capacitor.isNativePlatform();

/*
 * The authority must carry the tenant id in the path. This tenant's OIDC discovery document
 * returns the issuer on the GUID host (https://<tenantId>.ciamlogin.com/<tenantId>/v2.0), and
 * msal-browser 5.17 validates that issuer against the configured authority — a validation that
 * did not exist in 5.8. With a subdomain-only authority no rule matches and discovery fails with
 * endpoints_resolution_error. Using the tenant id as the path segment makes the issuer match.
 * Falls back to the tenant domain form (MSAL's own default transform) when the id is not set.
 */
const authority = tenantId
  ? `https://${tenantSubdomain}.ciamlogin.com/${tenantId}`
  : `https://${tenantSubdomain}.ciamlogin.com/${tenantSubdomain}.onmicrosoft.com`;

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri: isNative ? `${appId}://auth-redirect` : `${appUrl}/auth-redirect`,
    postLogoutRedirectUri: isNative ? `${appId}://auth-redirect` : `${appUrl}/`,
  },
  cache: {
    cacheLocation: 'localStorage' as const,
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'offline_access'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
